module.exports = __webpack_public_path__ + "img/0d42fe1e6aff68f7eeee85a7364343c3.svg";